import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Security from './components/Security';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <a href="#features" className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'}`}>
              Features
            </a>
            <a href="#security" className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'}`}>
              Security
            </a>
            <a href="#contact" className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-800 hover:text-cyan-500' : 'text-white hover:text-cyan-300'}`}>
              Contact
            </a>
          </div>
          
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://public.readdy.ai/ai/img_res/03b3c577-2c0d-4b85-b1ea-97438588720f.png" 
              alt="DOO NOVA-GROSIS NIS" 
              className="h-12 w-auto"
            />
          </div>
          
          <a href="#pricing" className={`px-6 py-2 rounded-full border transition-all whitespace-nowrap cursor-pointer ${scrolled ? 'border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white' : 'border-white text-white hover:bg-white hover:text-gray-900'}`}>
            Get Started
          </a>
        </div>
      </nav>

      <Hero />
      <Features />
      <HowItWorks />
      <Security />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
}